// Module
var code = "<div ng-if=\"ifLoading === undefined || (ifLoading !== undefined &amp;&amp; ifLoading)\" layout=row layout-align=\"center center\"><pros-spinner mode=mode diameter=diameter></pros-spinner></div>";
// Exports
module.exports = code;